const NewUserProfile = {
  email: '',
  password: '',
  _id: '',
}
export { NewUserProfile }
